var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('Button',{staticClass:"btn-show-more",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    Показать еще\n")]):_c('span',{staticClass:"link-show-more",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    Показать еще\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }